import { DocumentTextIcon, TerminalIcon } from "@heroicons/react/outline";
import { BracesIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

interface FunctionHeaderProps {
  name: string;
  showRawJSON: boolean;
  onToggle: () => void;
}

export const FunctionHeader = ({ name, showRawJSON, onToggle }: FunctionHeaderProps) => (
  <div className="flex items-center justify-between border-b border-gray-100 pb-3">
    <div className="mr-3 flex w-fit min-w-0 items-center rounded-md bg-blue-50 px-3 py-1.5">
      <TerminalIcon className="mr-2 h-4 w-4 flex-shrink-0 text-blue-600" />
      <span className="truncate font-medium text-blue-900">{name}</span>
    </div>
    <Button onClick={onToggle} variant="ghostGray" size="tinyButton">
      {showRawJSON ? (
        <>
          <DocumentTextIcon className="mr-1.5 h-3 w-3" />
          Show Function
        </>
      ) : (
        <>
          <BracesIcon className="mr-1.5 h-3 w-3" />
          Show JSON
        </>
      )}
    </Button>
  </div>
);
